import { css } from '@emotion/core'
import { mediumUp } from 'Utils'

export default ({ theme: { typography, colors, zIndex } }) => {
  return css`
    position: relative;
    display: flex;
    width: 100%;

    @media ${mediumUp} {
      max-width: 400px;
      margin-bottom: 0;
    }

    .search-input {
      height: 39px;
      width: 100%;

      @media ${mediumUp} {
        width: 80%;
      }

      appearance: none;
      padding: 6px 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
      font-size: 14px;
      line-height: 1.428571429;
      color: #555;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
      transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

      &:focus {
        outline: none;
      }
    }

    .search-submit {
      transition: background-color 220ms linear;
      background-color: ${colors.active};
      border-radius: 4px;
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      height: 39px;
      width: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 14px;
        height: 14px;
        fill: #fff;
      }

      &:hover {
        background-color: #5e1139;
        border-color: #81184e;
      }
    }
  `
}
